export default __webpack_public_path__ + "static/media/MyPhotoOne.031759c6.png";